import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import NotificationModal from 'bento-ordering/base/components/NotificationModal';
import PrimaryCta from 'bento-ordering/base/components/PrimaryCta';
import SecondaryCta from 'bento-ordering/base/components/SecondaryCta';

class BetweenMenusNotification extends React.Component {
  static propTypes = {
    closeModal: PropTypes.func,
    handlePrimaryCta: PropTypes.func,
    handleSecondaryCta: PropTypes.func
  };

  render() {
    return (
      <NotificationModal
        title="Items unavailable at this location"
        body="These menu items are unavailable at the time you selected. Choose a
            different time or view the menu that is available for that time."
        onClose={this.props.closeModal}
      >
        <PrimaryCta
          label="Set A New Time"
          handleClick={this.props.handlePrimaryCta}
          fullWidth
        />
        <Box
          mt={2}
          style={{
            textAlign: 'center'
          }}
        >
          <SecondaryCta
            label="View Menu"
            handleClick={this.props.handleSecondaryCta}
          />
        </Box>
      </NotificationModal>
    );
  }
}

export default BetweenMenusNotification;
